import React from 'react';
import { Grid, createStyles, makeStyles } from '@material-ui/core';

import { VehicleModel } from '../../../../../Models/VehicleModel';
import { theme } from '../../../../../theme';
import { EditAction } from '../../../../../shared/enum/EditAction';
import CutoutVehicleChip from './CutoutVehicleChip';

interface ICutoutVehicleChipListProps {
    selectedVehicles: VehicleModel[],
    vehicleList: VehicleModel[],
    searchText: string,
    onSelectVehicle?: (vehicle: VehicleModel) => void,
    onDeselectVehicle?: (vehicle: VehicleModel) => void
}

const useStyles = makeStyles(() => createStyles({
    vehicleComponents: {
        overflow: 'auto',
        maxHeight: '220px'
    }
}));

export function CutoutVehicleChipList({ selectedVehicles, vehicleList, searchText, onSelectVehicle, onDeselectVehicle }: ICutoutVehicleChipListProps) {
    const classes = useStyles();

    const getSelectedVehicles = () => {

        const currentSelected: VehicleModel[] = selectedVehicles.filter(v => v.editAction != EditAction.DELETE);
        
        if (currentSelected.length > 0) {
            return (
                currentSelected.map(vehicle => 
                    <CutoutVehicleChip
                        key={`chip-${vehicle.id}-selected`}
                        vehicle={ vehicle }
                        selected={ true }
                        onDeselectVehicle={ onDeselectVehicle } />
                )
            );
        }
    };

    const getNotSelectedVehicles = () => {
        let filteredList: VehicleModel[] = [];

        if (searchText != '') {
            filteredList = vehicleList.reduce((filtered: VehicleModel[], currentVehicle: VehicleModel) => {

                if (currentVehicle.nomenclature && currentVehicle.nomenclature.toLowerCase().includes(searchText.toLowerCase())) {
                    filtered.push(currentVehicle);
                }

                return filtered;
            }, []);
        }
        else {
            filteredList = [...vehicleList];
        }


        let renderList: VehicleModel[] = [...filteredList];

        if (selectedVehicles && selectedVehicles.length > 0) {
            renderList = filteredList.filter(vehicle => !selectedVehicles.some(sv => sv.id === vehicle.id && sv.editAction != EditAction.DELETE));
        }

        if (renderList && renderList.length > 0) {

            return (
                renderList.map(vehicle => 
                    <CutoutVehicleChip
                        key={`chip-${vehicle.id}-not-selected`}
                        vehicle={ vehicle }
                        selected={ false }
                        onSelectVehicle={ onSelectVehicle } />
                )
            );
        }
    };


    return (
        <Grid container className={ classes.vehicleComponents }>
            <Grid item xs={12}>
                { getSelectedVehicles() }
            </Grid>
            <Grid item xs={12} style={{ marginTop: theme.spacing(2) }}>
                { getNotSelectedVehicles() }
            </Grid>
        </Grid>
    );
}